'use strict';

angular
  .module('appSettingWelcome')
  .component('appSettingWelcome', {
    template: require('./welcome.template.html'),
    controller: ['$rootScope', '$resource', '$translate', 'AuthService', 'envService', 'Upload',
      function AppSettingWelcomeController($rootScope, $resource, $translate, AuthService, envService, Upload) {
        const APIURL = envService.read('apiUrl');

        $rootScope.mainmenu = 'appSetting';
        $rootScope.menu = 'welcome';

        this.doLogout = $rootScope.gLogout;
        this.loginMember = AuthService.loginMember();
        this.isLevel2Auth = AuthService.canEditAppSettings();
        this.saving = false;
        this.countries = ['TH', 'KR', 'JP'];
        this.textLocales = ['en', 'th', 'ko', 'ja'];
        const memberCountry = (this.loginMember && this.loginMember.COUNTRY_CODE)
          ? String(this.loginMember.COUNTRY_CODE).toUpperCase()
          : 'TH';
        this.country = this.countries.indexOf(memberCountry) >= 0 ? memberCountry : 'TH';
        this.placeholderHint = '{product} {percent} {invitePercent} {points} {invite} {reward}';
        this.textDefaults = {
          en: { title: '', subtitle: '', join_title: '' },
          th: { title: '', subtitle: '', join_title: '' },
          ko: { title: '', subtitle: '', join_title: '' },
          ja: { title: '', subtitle: '', join_title: '' },
        };

        this._resolveTextLang = () => {
          let saved = null;
          try { saved = window.localStorage.getItem('omgAdminLang'); } catch (e) { saved = null; }
          const raw = String(
            saved
            || $translate.use()
            || $translate.proposedLanguage()
            || 'en'
          ).slice(0, 2).toLowerCase();
          if (raw === 'jp') return 'ja';
          if (this.textLocales.indexOf(raw) >= 0) return raw;
          return 'en';
        };
        this.textLang = this._resolveTextLang();
        this.textLangLabel = () => {
          const map = { en: 'EN', th: 'TH', ko: 'KO', ja: 'JA' };
          return map[this.textLang] || String(this.textLang || '').toUpperCase();
        };
        $rootScope.$on('$translateChangeSuccess', () => {
          this.textLang = this._resolveTextLang();
          if (this.isLevel2Auth) {
            this.fillDefaults(false);
          }
        });

        this._emptyTexts = () => ({
          title: '',
          subtitle: '',
          join_title: '',
        });

        this._emptyTextsByLocale = () => {
          const out = {};
          this.textLocales.forEach((lang) => {
            out[lang] = this._emptyTexts();
          });
          return out;
        };

        this._emptyIntroByLocale = () => {
          const out = {};
          this.textLocales.forEach((lang) => {
            out[lang] = [];
          });
          return out;
        };

        this._normalizeRow = (raw) => {
          const src = raw || {};
          const texts = this._emptyTextsByLocale();
          const intro = this._emptyIntroByLocale();
          const srcTexts = src.texts || {};
          const srcIntro = src.intro_images || {};
          this.textLocales.forEach((lang) => {
            texts[lang] = Object.assign(this._emptyTexts(), srcTexts[lang] || {});
            intro[lang] = Array.isArray(srcIntro[lang])
              ? srcIntro[lang].slice()
              : [];
          });
          return {
            coupon_image_url: src.coupon_image_url || '',
            texts,
            intro_images: intro,
          };
        };

        this.rows = {
          TH: this._normalizeRow(null),
          KR: this._normalizeRow(null),
          JP: this._normalizeRow(null),
        };

        this.currentTexts = () => {
          const row = this.rows[this.country];
          if (!row.texts[this.textLang]) {
            row.texts[this.textLang] = this._emptyTexts();
          }
          return row.texts[this.textLang];
        };

        this.fieldPlaceholder = (key) => {
          const defaults = this.textDefaults[this.textLang] || {};
          return defaults[key] || '';
        };

        this.fillDefaults = (force) => {
          const defaults = this.textDefaults[this.textLang] || this._emptyTexts();
          const texts = this.currentTexts();
          Object.keys(defaults).forEach((k) => {
            if (force || !texts[k] || !String(texts[k]).trim()) {
              texts[k] = defaults[k] || '';
            }
          });
        };

        this.uploadCouponImage = (files) => {
          if (!files || !files.length || !this.isLevel2Auth) return;
          Upload.upload({
            url: `${APIURL}/admin/file/intro`,
            file: files[0],
          }).success((data) => {
            if (data && data.url) {
              this.rows[this.country].coupon_image_url = data.url;
            }
          }).error(() => {
            alert($translate.instant('알수 없는 에러 입니다.'));
          });
        };

        this.load = () => {
          $resource(`${APIURL}/admin/services/apps/settings`)
            .get()
            .$promise
            .then((data) => {
              const defaults = (data && data.welcome_text_defaults) || {};
              this.textLocales.forEach((lang) => {
                this.textDefaults[lang] = Object.assign(this._emptyTexts(), defaults[lang] || {});
              });
              const welcome = (data && data.welcome) || {};
              this.countries.forEach((code) => {
                this.rows[code] = this._normalizeRow(welcome[code]);
              });
              // Prefill empty fields with defaults so they are editable immediately.
              if (this.isLevel2Auth) {
                this.fillDefaults(false);
              }
            })
            .catch((err) => {
              if (err.data && err.data.msg) alert(err.data.msg);
              else alert($translate.instant('알수 없는 에러 입니다.'));
            });
        };

        this.save = () => {
          if (!this.isLevel2Auth) return;
          if (!confirm($translate.instant('환영 설정을 저장하시겠습니까?'))) return;
          this.saving = true;
          const welcome = {};
          this.countries.forEach((code) => {
            // Preserve intro_images (managed on Tutorial page).
            welcome[code] = this._normalizeRow(this.rows[code]);
          });
          const Res = $resource(`${APIURL}/admin/services/apps/settings`, {}, {
            update: { method: 'PUT' },
          });
          Res.update({ welcome })
            .$promise
            .then((data) => {
              const saved = (data && data.welcome) || welcome;
              this.countries.forEach((code) => {
                this.rows[code] = this._normalizeRow(saved[code]);
              });
              alert($translate.instant('수정되었습니다.'));
            })
            .catch((err) => {
              if (err.data && err.data.msg) alert(err.data.msg);
              else alert($translate.instant('알수 없는 에러 입니다.'));
            })
            .finally(() => {
              this.saving = false;
            });
        };

        this.load();
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/app-setting/welcome/welcome.component.js